import React from 'react'
import PropTypes from 'prop-types'
import { useFeature } from '@pcln/feature-components'
import { ResponsiveChangeSearchHeader } from '@pcln/fly-search-header-react'
import { useSelector } from 'react-redux'
import { getGraphURL } from '@mfs/client/utils/getServiceUrl'
import { usePCLNExpt } from '../../../../common/PCLNExpt/PCLNExptContext'
import { useIsMobile } from '../../helpers/useIsMobile'

const formatPassengers = (passengers) => ({
  lapInfants: passengers?.infants ?? 0,
  ...passengers,
})

const formatRtSlices = (slices) => {
  const slice1 = slices?.[0]?.split?.('-')
  const slice2 = slices?.[1]?.split?.('-')
  return [
    {
      origAirportCode: slice1?.[0],
      destAirportCode: slice1?.[1],
      date: slice1?.[2],
      returnDate: slice2?.[2],
    },
  ]
}

const formatSlices = (slices, tripType) =>
  tripType === 'RT'
    ? formatRtSlices(slices)
    : slices.map((slice) => {
        const sliceParts = slice?.split?.('-')
        return {
          origAirportCode: sliceParts?.[0],
          destAirportCode: sliceParts?.[1],
          date: sliceParts?.[2],
        }
      })

const subLabelMap = {
  adults: '(ages 12 and up)',
  children: '(ages 2-11)',
  lapInfants: '(under 2)',
}

// no-results can't use this wrapper as it requires redux
const ResponsiveChangeSearchHeaderWrapper = ({
  defaultTripSlices = [],
  defaultTripType = 'RT',
  defaultPassengers = { adults: 1 },
  defaultCabinClass = 'ECO',
  modifyNow,
  ...props
}) => {
  const isMobileView = useIsMobile()
  return (
    <ResponsiveChangeSearchHeader
      defaultPassengers={formatPassengers(defaultPassengers)}
      defaultCabinClass={defaultCabinClass}
      defaultTripSlices={formatSlices(defaultTripSlices, defaultTripType)}
      defaultTripType={defaultTripType}
      subLabelMap={useFeature('flights.useMultipax') ? subLabelMap : null}
      lapInfantLabel={useFeature('flights.useMultipax') ? 'Infants on lap' : null}
      iframeEnabled={useFeature('whiteLabel.iframeEnabled', false)}
      modifyNow={modifyNow}
      maxChildren={6}
      shouldCountLapInfant
      isMobileView={isMobileView}
      getGraphURL={getGraphURL}
      {...props}
    />
  )
}

// Listings stores phoneBookInfo in redux, which noresults and details don't use, so it needs
// it's own additional wrapper to use it
const ResponsiveChangeSearchHeaderListingsWrapper = ({ isMobile, handleBackLink, ...props }) => {
  const { pclnExpt } = usePCLNExpt()
  const phoneNumber = useSelector((state) => state.phoneBookInfo?.phoneNumber ?? '')

  let phoneNumberForIconSeti = ''
  if (phoneNumber && isMobile) {
    phoneNumberForIconSeti = phoneNumber
  }

  return (
    <ResponsiveChangeSearchHeaderWrapper
      hidePhone={!phoneNumberForIconSeti}
      phoneNumber={phoneNumberForIconSeti}
      pclnExpt={pclnExpt}
      handleBackLink={handleBackLink}
      {...props}
    />
  )
}

ResponsiveChangeSearchHeaderListingsWrapper.propTypes = {
  isMobile: PropTypes.bool,
  handleBackLink: PropTypes.func,
}

ResponsiveChangeSearchHeaderWrapper.propTypes = {
  defaultTripType: PropTypes.string,
  defaultCabinClass: PropTypes.string,
  defaultPassengers: PropTypes.object,
  defaultTripSlices: PropTypes.array,
  defaultAirports: PropTypes.object,
  isWhiteLabel: PropTypes.bool,
  pclnExpt: PropTypes.any,
  urlRoot: PropTypes.string,
  modifyNow: PropTypes.bool,
  queryParams: PropTypes.object,
  filterOnClick: PropTypes.func,
  displayFlexibleDatesCheckbox: PropTypes.func,
}

export { ResponsiveChangeSearchHeaderWrapper, ResponsiveChangeSearchHeaderListingsWrapper }
